function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Updated"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "small-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-5",
    d: "M11.25,7.5h4.37v3.12H11.25Zm0,5h4.37v3.12H11.25Zm-6.87,0H8.75v3.12H4.38Zm0-5H8.75v3.12H4.38Zm14-5.62A1.66,1.66,0,0,1,20,3.54V18.33A1.67,1.67,0,0,1,18.33,20H1.67A1.67,1.67,0,0,1,0,18.33V3.54A1.66,1.66,0,0,1,1.67,1.88H4.38V.62a.62.62,0,0,1,1.24,0V1.88H9.38V.62a.62.62,0,1,1,1.24,0V1.88h3.76V.62a.62.62,0,1,1,1.24,0V1.88Zm.42,16.45V3.54a.42.42,0,0,0-.42-.42H15.62V4.38a.62.62,0,0,1-1.24,0V3.12H10.62V4.38a.62.62,0,1,1-1.24,0V3.12H5.62V4.38a.62.62,0,0,1-1.24,0V3.12H1.67a.42.42,0,0,0-.42.42V18.33a.42.42,0,0,0,.42.42H18.33A.42.42,0,0,0,18.75,18.33Z",
    style: {
      fill: "#2774ae",
      fillRule: "evenodd"
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.34bb9369a4084a0959b66804799eabb8.svg";
export { ForwardRef as ReactComponent };